import { render, staticRenderFns } from "./steamxyIndex.vue?vue&type=template&id=495d5342&scoped=true&"
import script from "./steamxyIndex.vue?vue&type=script&lang=js&"
export * from "./steamxyIndex.vue?vue&type=script&lang=js&"
import style0 from "./steamxyIndex.vue?vue&type=style&index=0&id=495d5342&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "495d5342",
  null
  
)

export default component.exports